/**
* datepicker component using 3rd party lib 'react-datepicker'
*
* Created by Tom on 15/06/18
*/

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import DatePicker from 'react-datepicker'

// style import
import './style.scss'
import 'react-datepicker/dist/react-datepicker.css'

class CustomDatePicker extends Component {

    // open the datepicker dropdown if the icon has been clicked
    _onIconClick() {
        this._calendar.setOpen(true)
    }

    render() {

        const { icon, date, onDateChange, minDate } = this.props
        return (
            <div className="datepicker">

                {/* 3rd party datepicker component */}
                <DatePicker
                    ref={(c) => this._calendar = c}
                    dateFormat="DD MMM YY"
                    selected={date}
                    onChange={onDateChange}
                    minDate={minDate}
                    onFocus={::this._onIconClick}/>

                {/* icon wrapper */}
                <div
                    className="datepicker__icon-wrapper"
                    onClick={::this._onIconClick}>
                    <img
                        src={icon}
                        className="datepicker__icon-wrapper__icon"
                        alt="Datepicker icon" />
                </div>

            </div>
        )
    }
}

// define the prop types
CustomDatePicker.propTypes = {
    icon: PropTypes.string,
    date: PropTypes.object,
    onDateChange: PropTypes.func
}

export default CustomDatePicker



// WEBPACK FOOTER //
// ./src/components/CustomDatePicker/index.js